// Обработка плавной прокрутки к якорям
document.addEventListener('DOMContentLoaded', function() {
  // Устанавливаем CSS переменные для каждого якоря на основе data-атрибутов
  document.querySelectorAll('.item-selection-static-section [id][data-anchor-offset]').forEach(function(element) {
    if (element instanceof HTMLElement) {
      const offset = element.getAttribute('data-anchor-offset');
      const offsetMobile = element.getAttribute('data-anchor-offset-mobile');
      
      if (offset) {
        const offsetValue = parseInt(offset);
        if (!isNaN(offsetValue)) {
          element.style.setProperty('--anchor-offset', offsetValue + 'px');
        }
      }
      
      if (offsetMobile) {
        const offsetMobileValue = parseInt(offsetMobile);
        if (!isNaN(offsetMobileValue)) {
          element.style.setProperty('--anchor-offset-mobile', offsetMobileValue + 'px');
        }
      } else if (offset) {
        // Если мобильный offset не задан, используем значение для десктопа
        const offsetValue = parseInt(offset);
        if (!isNaN(offsetValue)) {
          element.style.setProperty('--anchor-offset-mobile', offsetValue + 'px');
        }
      }
    }
  });
  
  // Функция для получения offset из data-атрибута или значения по умолчанию
  function getAnchorOffset(element) {
    if (window.innerWidth <= 767) {
      const offsetMobile = element.getAttribute('data-anchor-offset-mobile');
      if (offsetMobile) {
        const offsetValue = parseInt(offsetMobile);
        if (!isNaN(offsetValue)) {
          return offsetValue;
        }
      }
      // Если мобильный offset не задан, используем десктопный
      const offset = element.getAttribute('data-anchor-offset');
      if (offset) {
        const offsetValue = parseInt(offset);
        if (!isNaN(offsetValue)) {
          return offsetValue;
        }
      }
      return 100;
    } else {
      const offset = element.getAttribute('data-anchor-offset');
      if (offset) {
        const offsetValue = parseInt(offset);
        if (!isNaN(offsetValue)) {
          return offsetValue;
        }
      }
      return 120;
    }
  }
  
  // Обработка кликов по ссылкам с якорями
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href === '#' || href === '#!') return;
      
      const targetId = href.substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement && targetElement.closest('.item-selection-static-section')) {
        e.preventDefault();
        
        const scrollOffset = getAnchorOffset(targetElement);
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - scrollOffset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
  
  // Обработка прямого перехода по якорю при загрузке страницы
  if (window.location.hash) {
    const targetId = window.location.hash.substring(1);
    const targetElement = document.getElementById(targetId);
    
    if (targetElement && targetElement.closest('.item-selection-static-section')) {
      setTimeout(function() {
        const scrollOffset = getAnchorOffset(targetElement);
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - scrollOffset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }, 100);
    }
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.item-selection-static-section');
  
  sections.forEach(function(section) {
    const grids = section.querySelectorAll('[data-grid-id]');
    
    grids.forEach(function(grid) {
      const gridId = grid.getAttribute('data-grid-id');
      const controlsId = gridId.replace('grid-', 'controls-');
      const controls = section.querySelector(`[data-controls-id="${controlsId}"]`);
      
      if (!controls) return;
      
      const prevBtn = controls.querySelector('.sliderControlVertical__prev');
      const nextBtn = controls.querySelector('.sliderControlVertical__next');
      const bullets = controls.querySelectorAll('.sliderControlVertical__pagination-bullet');
      
      let currentPage = 1;
      let totalPages = 1;
      let isAnimating = false;
      
      // Вычисляем количество товаров на странице в зависимости от размера экрана
      function getProductsPerPage() {
        const width = window.innerWidth;
        if (width >= 1200) return 6; // 3 колонки × 2 ряда
        if (width >= 768) return 8; // 4 колонки × 2 ряда для планшетов
        return 6; // 3 колонки × 2 ряда для мобильных - всегда показываем 6 товаров
      }
      
      // Создаем точки пагинации
      function createPagination() {
        const pagination = controls.querySelector('.sliderControlVertical__pagination');
        const totalProducts = parseInt(pagination.getAttribute('data-total-products')) || 0;
        const productsPerPage = getProductsPerPage();
        
        totalPages = Math.ceil(totalProducts / productsPerPage);
        
        // Всегда показываем пагинацию, если есть товары
        if (totalPages <= 1 || totalProducts === 0) {
          controls.style.display = 'none';
          controls.style.visibility = 'hidden';
          return;
        }
        
        // Принудительно показываем пагинацию
        controls.style.display = 'flex';
        controls.style.visibility = 'visible';
        controls.style.opacity = '1';
        pagination.innerHTML = '';
        
        for (let i = 1; i <= totalPages; i++) {
          const bullet = document.createElement('span');
          bullet.className = 'sliderControlVertical__pagination-bullet';
          if (i === 1) {
            bullet.classList.add('sliderControlVertical__pagination-bullet--active');
          }
          bullet.setAttribute('tabindex', '0');
          bullet.setAttribute('role', 'button');
          bullet.setAttribute('aria-label', 'Go to slide ' + i);
          bullet.setAttribute('data-page', i);
          bullet.addEventListener('click', function() {
            goToPage(i);
          });
          pagination.appendChild(bullet);
        }
        
        updateBullets();
      }
      
      function updateBullets() {
        const bullets = controls.querySelectorAll('.sliderControlVertical__pagination-bullet');
        bullets.forEach(function(bullet, index) {
          if (index + 1 === currentPage) {
            bullet.classList.add('sliderControlVertical__pagination-bullet--active');
          } else {
            bullet.classList.remove('sliderControlVertical__pagination-bullet--active');
          }
        });
      }
      
      function updateGrid() {
        const isMobile = window.innerWidth <= 767;
        
        // Если всего одна страница или нет товаров, показываем все товары
        if (totalPages <= 1) {
          const products = grid.querySelectorAll('.item-selection-product-card');
          products.forEach(function(product) {
            if (product) {
              // Просто удаляем inline display, чтобы карточка отображалась нормально
              product.style.display = '';
              product.style.opacity = '';
              product.style.transform = '';
            }
          });
          updateBullets();
          return;
        }
        
        const productsPerPage = getProductsPerPage();
        const products = grid.querySelectorAll('.item-selection-product-card');
        
        if (isMobile) {
          // На мобильных используем плавную анимацию
          const targetPage = currentPage;
          
          // Сначала скрываем все товары не текущей страницы синхронно
          products.forEach(function(product, index) {
            if (product) {
              const pageNumber = Math.floor(index / productsPerPage) + 1;
              if (pageNumber !== targetPage) {
                product.style.display = 'none';
                product.style.opacity = '';
                product.style.transform = '';
              }
            }
          });
          
          // Собираем товары текущей страницы
          const currentPageProducts = [];
          products.forEach(function(product, index) {
            if (product) {
              const pageNumber = Math.floor(index / productsPerPage) + 1;
              if (pageNumber === targetPage) {
                currentPageProducts.push(product);
                product.style.display = '';
                // Начальное состояние для анимации
                product.style.opacity = '0';
                product.style.transform = 'translateX(15px)';
              }
            }
          });
          
          // Анимация появления в следующем кадре
          requestAnimationFrame(function() {
            currentPageProducts.forEach(function(product) {
              product.style.opacity = '1';
              product.style.transform = 'translateX(0)';
            });
          });
        } else {
          // На десктопе используем обычное переключение
          products.forEach(function(product, index) {
            if (product) {
              const pageNumber = Math.floor(index / productsPerPage) + 1;
              if (pageNumber === currentPage) {
                product.style.display = '';
                product.style.opacity = '';
                product.style.transform = '';
              } else {
                product.style.display = 'none';
                product.style.opacity = '';
                product.style.transform = '';
              }
            }
          });
        }
        
        updateBullets();
        
        // Обновляем состояние кнопок
        if (currentPage === 1) {
          prevBtn.classList.add('swiper-button-disabled');
          prevBtn.setAttribute('aria-disabled', 'true');
        } else {
          prevBtn.classList.remove('swiper-button-disabled');
          prevBtn.setAttribute('aria-disabled', 'false');
        }
        
        if (currentPage === totalPages) {
          nextBtn.classList.add('swiper-button-disabled');
          nextBtn.setAttribute('aria-disabled', 'true');
        } else {
          nextBtn.classList.remove('swiper-button-disabled');
          nextBtn.setAttribute('aria-disabled', 'false');
        }
      }
      
      // Синхронизация высоты баннера с сеткой карточек
      function syncBannerHeight() {
        const staticItem = grid.closest('.item-selection-static-item');
        if (!staticItem) return;
        
        const bannerSection = staticItem.querySelector('.banner-section');
        const bannerContent = staticItem.querySelector('.banner-content');
        const productsGrid = staticItem.querySelector('.item-selection-products-grid');
        
        if (bannerSection && bannerContent && productsGrid && window.innerWidth >= 1200) {
          const gridHeight = productsGrid.offsetHeight;
          if (gridHeight > 0) {
            bannerContent.style.height = gridHeight + 'px';
            bannerContent.style.minHeight = gridHeight + 'px';
          }
        } else if (bannerContent && window.innerWidth < 1200) {
          bannerContent.style.height = '';
          bannerContent.style.minHeight = '';
        }
      }
      
      // Переход на страницу
      function goToPage(page) {
        if (page < 1 || page > totalPages) return;
        if (isAnimating) return; // Блокируем переходы во время анимации
        if (page === currentPage) return; // Не переключаем на ту же страницу
        
        // Блокируем дальнейшие переходы
        isAnimating = true;
        
        // Сразу устанавливаем новую страницу
        currentPage = page;
        
        // Синхронно обновляем DOM
        updateGrid();
        
        // Разблокируем после завершения анимации
        setTimeout(function() {
          isAnimating = false;
          syncBannerHeight();
        }, 300);
      }
      
      // Обработчики событий
      // Стрелка сверху (prev) - листает вверх (предыдущую страницу)
      prevBtn.addEventListener('click', function() {
        if (currentPage > 1 && !prevBtn.classList.contains('swiper-button-disabled')) {
          goToPage(currentPage - 1);
        }
      });
      
      // Стрелка снизу (next) - листает вниз (следующую страницу)
      nextBtn.addEventListener('click', function() {
        if (currentPage < totalPages && !nextBtn.classList.contains('swiper-button-disabled')) {
          goToPage(currentPage + 1);
        }
      });
      
      // Обработка свайпа по сетке товаров - листание по колонкам
      let gridSwipeStart = null;
      let isSwiping = false;
      let swipeDirection = null;
      const staticItem = grid.closest('.item-selection-static-item');
      
      grid.addEventListener('touchstart', function(e) {
        // Игнорируем свайп, если клик по кнопке quick-add-button
        if (e.target && e.target.closest && e.target.closest('.quick-add-button-wrapper')) {
          return;
        }
        if (window.innerWidth <= 767 && !isAnimating) {
          gridSwipeStart = { 
            x: e.touches[0].clientX, 
            y: e.touches[0].clientY, 
            time: Date.now(),
            scrollY: window.scrollY
          };
          isSwiping = false;
          swipeDirection = null;
        }
      }, { passive: true });
      
      grid.addEventListener('touchmove', function(e) {
        if (!gridSwipeStart || window.innerWidth > 767 || isAnimating) return;
        
        const touch = e.touches[0];
        const diffX = gridSwipeStart.x - touch.clientX;
        const diffY = Math.abs(gridSwipeStart.y - touch.clientY);
        
        // Если горизонтальное движение больше вертикального, это свайп
        if (Math.abs(diffX) > 10 && Math.abs(diffX) > diffY * 1.5) {
          if (!isSwiping) {
            isSwiping = true;
            swipeDirection = diffX > 0 ? 'left' : 'right';
            // Добавляем класс для блокировки скролла
            if (staticItem) {
              staticItem.classList.add('swiping');
            }
          }
          // Предотвращаем скролл страницы при горизонтальном свайпе
          e.preventDefault();
        } else if (isSwiping && Math.abs(diffY) > Math.abs(diffX) * 1.5) {
          // Если начали вертикальный скролл, отменяем свайп
          isSwiping = false;
          swipeDirection = null;
          if (staticItem) {
            staticItem.classList.remove('swiping');
          }
        }
      }, { passive: false });
      
      grid.addEventListener('touchend', function(e) {
        // Убираем класс блокировки скролла
        if (staticItem) {
          staticItem.classList.remove('swiping');
        }
        
        // Игнорируем свайп, если клик по кнопке quick-add-button или идет анимация
        if (!gridSwipeStart || (e.target && e.target.closest && e.target.closest('.quick-add-button-wrapper')) || window.innerWidth > 767 || isAnimating) {
          gridSwipeStart = null;
          isSwiping = false;
          swipeDirection = null;
          return;
        }
        
        // Дополнительная проверка блокировки перед обработкой свайпа
        if (isAnimating) {
          gridSwipeStart = null;
          isSwiping = false;
          swipeDirection = null;
          return;
        }
        
        const swipeEnd = { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY, time: Date.now() };
        const diffX = gridSwipeStart.x - swipeEnd.x;
        const diffY = Math.abs(gridSwipeStart.y - swipeEnd.y);
        const diffTime = swipeEnd.time - gridSwipeStart.time;
        
        // Проверяем, был ли это горизонтальный свайп
        if (isSwiping && Math.abs(diffX) > 50 && diffY < 150 && diffTime < 500) {
          // Предотвращаем скролл страницы
          e.preventDefault();
          
          if (swipeDirection === 'left' && diffX > 0) {
            // Свайп влево - следующая страница
            if (nextBtn && !nextBtn.classList.contains('swiper-button-disabled')) {
              goToPage(currentPage + 1);
            }
          } else if (swipeDirection === 'right' && diffX < 0) {
            // Свайп вправо - предыдущая страница
            if (prevBtn && !prevBtn.classList.contains('swiper-button-disabled')) {
              goToPage(currentPage - 1);
            }
          }
        }
        
        gridSwipeStart = null;
        isSwiping = false;
        swipeDirection = null;
      }, { passive: false });
      
      grid.addEventListener('touchcancel', function(e) {
        // Убираем класс блокировки скролла при отмене
        if (staticItem) {
          staticItem.classList.remove('swiping');
        }
        gridSwipeStart = null;
        isSwiping = false;
        swipeDirection = null;
      }, { passive: true });
      
      // Инициализация
      createPagination();
      updateGrid();
      setTimeout(syncBannerHeight, 100);
      
      // Обновление при изменении размера окна
      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          currentPage = 1;
          createPagination();
          updateGrid();
          setTimeout(syncBannerHeight, 150);
        }, 250);
      });
    });
  });
});

